<template>
  <div class="sidebar">
    <div class="block target">
      <h4>提供服務的對象</h4>
      <ul>
        <li>
          <router-link to="/services">
            <i class="fas fa-male"></i>第一種人
          </router-link>
        </li>
        <li>
          <router-link to="/services/forsomeone2">
            <i class="fas fa-male"></i>第二種人
          </router-link>
        </li>
        <li>
          <router-link to="/services/forsomeone3">
            <i class="fas fa-male"></i>第三種人
          </router-link>
        </li>
        <li>
          <router-link to="/services/forsomeone4">
            <i class="fas fa-male"></i>第四種人
          </router-link>
        </li>
      </ul>

      <!-- <router-link :to="{ name: 'services' + index + ''}"
      href="#" v-for="(item, index) in targets" :key="index">
        <i class="fas fa-male"></i>
        {{ item }}
      </router-link>-->
    </div>
    <div class="block from">
      <Form></Form>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Form from '@/components/only_form.vue';

export default {
  data() {
    return {
      // targets: ['第一種人', '第二種人', '第三種人', '第四種人'],
    };
  },
  components: {
    Form,
  },
};
</script>

<style scoped lang="scss">
.activee {
  // background-color: #bee6f5;
  background-color: #ddc3a1;

}
.sidebar {
  .block {
    background-color: rgba(240, 238, 238, 0.5);
    padding: 30px 30px 8px 30px;
    margin: 20px 0;
    border-radius: 10px;
  }
  .target {
    h3 {
      margin-bottom: 20px;
    }
    ul {
      padding: 0;
      li {
        display: flex;
        font-size: 1.2rem;
        margin-bottom: 20px;
        a {
          color: #333;
          text-decoration: none;
          padding: 10px 40px;
          border-radius: 50px;
        }
        a:hover {
          // background-color: #bee6f5;
          background-color: #ddc3a1;
        }
        .fas {
          margin-right: 20px;
          font-size: 1.4rem;
        }
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .sidebar {
    .target {
      ul {
        li {
          a{
            padding: 10px 20px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .sidebar {
    .target {
      ul {
        li {
          a{
            padding: 10px 40px;
          }
        }
      }
    }
  }
}
</style>
